// extracted by mini-css-extract-plugin
export default {"list":"CategoriesList_list__NbVAn","item":"CategoriesList_item__9Ml1A"};